import maple from '../../assets3d/maple.fbx';
import palmtree from '../../assets3d/palm-tree.fbx';
import fern1 from '../../assets3d/fern-1.fbx';
import fern2 from '../../assets3d/fern-2.fbx';
import thickLeavesPlant from '../../assets3d/thick-leaves-plant.fbx';
import thinLeavesPlant from '../../assets3d/thin-leaves-plant.fbx';

export default [
    {
        url: maple,
        quebec: true,
        copies: [
            {
                position: {
                    x: 0,
                    y: 0,
                    z: 0,
                },
                scale: 0.75,
            },
        ],
    },
    {
        url: palmtree,
        copies: [
            {
                position: {
                    x: -13,
                    y: 0,
                    z: 14,
                },
                scale: 0.6,
            },
            {
                position: {
                    x: -13,
                    y: 0,
                    z: -10,
                },
                scale: 0.6,
            },
            {
                position: {
                    x: 13.5,
                    y: 0,
                    z: 13.5,
                },
                scale: 0.6,
            },
            {
                position: {
                    x: 8,
                    y: 0,
                    z: 9,
                },
                rotation: {
                    y: 10,
                },
                scale: 0.6,
            },
            {
                position: {
                    x: 14,
                    y: 0,
                    z: 0,
                },
                rotation: {
                    y: 100,
                },
                scale: 0.6,
            },
        ],
    },
    {
        url: fern1,
        quebec: true,
        copies: [
            {
                position: {
                    x: -5,
                    y: 0,
                    z: 0,
                },
                scale: 0.1,
            },
            {
                position: {
                    x: -2,
                    y: 0,
                    z: 10,
                },
                scale: 0.05,
            },
            {
                position: {
                    x: 2,
                    y: 0,
                    z: 13,
                },
                scale: 0.075,
                rotation: {
                    y: 45,
                },
            },
            {
                position: {
                    x: 0,
                    y: 0,
                    z: 15,
                },
                scale: 0.06,
                rotation: {
                    y: 90,
                },
            },
            {
                position: {
                    x: 0,
                    y: 0,
                    z: 15,
                },
                scale: 0.06,
                rotation: {
                    y: 90,
                },
            },
            {
                position: {
                    x: 10,
                    y: 0,
                    z: 4,
                },
                scale: 0.1,
                rotation: {
                    y: 340,
                },
            },
            {
                position: {
                    x: 5,
                    y: 0,
                    z: 6,
                },
                scale: 0.1,
                rotation: {
                    y: 30,
                },
            },
            {
                position: {
                    x: 9,
                    y: 0,
                    z: -8,
                },
                scale: 0.16,
                rotation: {
                    y: 160,
                },
            },
        ],
    },
    {
        url: fern2,
        copies: [
            {
                position: {
                    x: -10,
                    y: 0,
                    z: -10,
                },
                scale: 0.1,
                rotation: {
                    y: 0,
                },
            },
            {
                position: {
                    x: -9,
                    y: 0,
                    z: 7,
                },
                scale: 0.1,
                rotation: {
                    y: 40,
                },
            },
            {
                position: {
                    x: -12,
                    y: 0,
                    z: 7,
                },
                scale: 0.1,
                rotation: {
                    y: 80,
                },
            },
            {
                position: {
                    x: -12,
                    y: 0,
                    z: -2,
                },
                scale: 0.05,
                rotation: {
                    y: 120,
                },
            },
            {
                position: {
                    x: -8,
                    y: 0,
                    z: -3,
                },
                scale: 0.06,
                rotation: {
                    y: 160,
                },
            },
            {
                position: {
                    x: 5,
                    y: 0,
                    z: -12,
                },
                scale: 0.08,
                rotation: {
                    y: 180,
                },
            },
            {
                position: {
                    x: -2,
                    y: 0,
                    z: -11,
                },
                scale: 0.1,
                rotation: {
                    y: 200,
                },
            },
        ],
    },
    {
        url: thickLeavesPlant,
        copies: [
            {
                position: {
                    x: -10,
                    y: 0,
                    z: 10,
                },
                scale: 3,
                rotation: {
                    y: 0,
                },
            },
            {
                position: {
                    x: -10,
                    y: 0,
                    z: 0,
                },
                scale: 3,
                rotation: {
                    y: 35,
                },
            },
            {
                position: {
                    x: -12,
                    y: 0,
                    z: 4,
                },
                scale: 3,
                rotation: {
                    y: 70,
                },
            },
            {
                position: {
                    x: -5,
                    y: 0,
                    z: 15,
                },
                scale: 1,
                rotation: {
                    y: 45,
                },
            },
            {
                position: {
                    x: -4,
                    y: 0,
                    z: 14,
                },
                scale: 1.2,
                rotation: {
                    y: 90,
                },
            },
            {
                position: {
                    x: -5,
                    y: 0,
                    z: 13,
                },
                scale: 1.4,
                rotation: {
                    y: 90,
                },
            },
            {
                position: {
                    x: -8,
                    y: 0,
                    z: -5,
                },
                scale: 1.2,
                rotation: {
                    y: 120,
                },
            },
            {
                position: {
                    x: -7,
                    y: 0,
                    z: -6,
                },
                scale: 1.1,
                rotation: {
                    y: 140,
                },
            },
            {
                position: {
                    x: -6,
                    y: 0,
                    z: -5,
                },
                scale: 0.9,
                rotation: {
                    y: 160,
                },
            },
            {
                position: {
                    x: -5,
                    y: 0,
                    z: -4,
                },
                scale: 0.8,
                rotation: {
                    y: 180,
                },
            },
            {
                position: {
                    x: -4.5,
                    y: 0,
                    z: -3,
                },
                scale: 0.75,
                rotation: {
                    y: 200,
                },
            },
            {
                position: {
                    x: -3,
                    y: 0,
                    z: -2,
                },
                scale: 0.4,
                rotation: {
                    y: 220,
                },
            },
            {
                position: {
                    x: 3,
                    y: 0,
                    z: -2,
                },
                scale: 0.6,
                rotation: {
                    y: 220,
                },
            },
            {
                position: {
                    x: 6,
                    y: 0,
                    z: -10,
                },
                scale: 2,
                rotation: {
                    y: 240,
                },
            },
            {
                position: {
                    x: 4,
                    y: 0,
                    z: -8,
                },
                scale: 1.8,
                rotation: {
                    y: 260,
                },
            },
            {
                position: {
                    x: 2,
                    y: 0,
                    z: -4,
                },
                scale: 1.5,
                rotation: {
                    y: 280,
                },
            },
            {
                position: {
                    x: 12,
                    y: 0,
                    z: 8,
                },
                scale: 1.5,
                rotation: {
                    y: 280,
                },
            },
            {
                position: {
                    x: 10,
                    y: 0,
                    z: 6,
                },
                scale: 1.2,
                rotation: {
                    y: 300,
                },
            },
            {
                position: {
                    x: 10,
                    y: 0,
                    z: 4,
                },
                scale: 1,
                rotation: {
                    y: 300,
                },
            },
            {
                position: {
                    x: 10,
                    y: 0,
                    z: 2,
                },
                scale: 0.5,
                rotation: {
                    y: 320,
                },
            },
            {
                position: {
                    x: 10,
                    y: 0,
                    z: 0,
                },
                scale: 0.3,
                rotation: {
                    y: 340,
                },
            },
        ],
    },
    {
        url: thinLeavesPlant,
        copies: [
            {
                position: {
                    x: 5,
                    y: 0,
                    z: 0,
                },
                scale: 0.06,
                rotation: {
                    y: 0,
                },
            },
            {
                position: {
                    x: 5,
                    y: 0,
                    z: 5,
                },
                scale: 0.04,
                rotation: {
                    y: 45,
                },
            },
            {
                position: {
                    x: 2,
                    y: 0,
                    z: 4,
                },
                scale: 0.03,
                rotation: {
                    y: 80,
                },
            },
            {
                position: {
                    x: -2,
                    y: 0,
                    z: 7,
                },
                scale: 0.07,
                rotation: {
                    y: 45,
                },
            },
            {
                position: {
                    x: -6,
                    y: 0,
                    z: 12,
                },
                scale: 0.05,
                rotation: {
                    y: 45,
                },
            },
            {
                position: {
                    x: -6,
                    y: 0,
                    z: 5,
                },
                scale: 0.02,
                rotation: {
                    y: 45,
                },
            },
            {
                position: {
                    x: -3,
                    y: 0,
                    z: 3,
                },
                scale: 0.015,
                rotation: {
                    y: 90,
                },
            },
            {
                position: {
                    x: -6,
                    y: 0,
                    z: 4,
                },
                scale: 0.015,
                rotation: {
                    y: 115,
                },
            },
            {
                position: {
                    x: -8,
                    y: 0,
                    z: 3,
                },
                scale: 0.02,
                rotation: {
                    y: 115,
                },
            },
            {
                position: {
                    x: 5,
                    y: 0,
                    z: -4,
                },
                scale: 0.01,
                rotation: {
                    y: 280,
                },
            },
            {
                position: {
                    x: 0,
                    y: 0,
                    z: -10,
                },
                scale: 0.02,
                rotation: {
                    y: 300,
                },
            },
            {
                position: {
                    x: 2,
                    y: 0,
                    z: -12,
                },
                scale: 0.03,
                rotation: {
                    y: 300,
                },
            },
            {
                position: {
                    x: 2,
                    y: 0,
                    z: -15,
                },
                scale: 0.04,
                rotation: {
                    y: 320,
                },
            },
            {
                position: {
                    x: 7,
                    y: 0,
                    z: 12,
                },
                scale: 0.03,
                rotation: {
                    y: 340,
                },
            },
            {
                position: {
                    x: 6,
                    y: 0,
                    z: 11,
                },
                scale: 0.02,
                rotation: {
                    y: 20,
                },
            },
            {
                position: {
                    x: 6,
                    y: 0,
                    z: 5,
                },
                scale: 0.03,
                rotation: {
                    y: 40,
                },
            },
            {
                position: {
                    x: 0,
                    y: 0,
                    z: 7,
                },
                scale: 0.02,
                rotation: {
                    y: 20,
                },
            },
            {
                position: {
                    x: 1,
                    y: 0,
                    z: 5,
                },
                scale: 0.02,
                rotation: {
                    y: 40,
                },
            },
        ],
    },
];
